export default "__VITE_ASSET__BiArCJJI__"